import { render, staticRenderFns } from "./retained.vue?vue&type=template&id=0798a512"
import script from "./retained.vue?vue&type=script&lang=js"
export * from "./retained.vue?vue&type=script&lang=js"
import style0 from "./retained.vue?vue&type=style&index=0&id=0798a512&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports